export default __webpack_public_path__ + "static/media/ae-logo-dk.22ea7392.png";